import React, { useRef, useEffect } from 'react'
import injectStyles from 'react-jss'
import moment from 'moment'
import GenericFlatButton from '../../GenericFlatButton'
import CloseIcon from 'Assets/Images/icons/modalClose'
import { styles } from './styles'
import {
  PTO_REQUEST_PAID_TYPE_OF_TIME_OFF_ENUM,
  PTO_REQUEST_TYPE_ENUM_TO_READABLE,
  PTO_REQUEST_UNPAID_TYPE_OF_TIME_OFF_ENUM,
} from '../../../shared/constants'

const ViewTimeOffRequestModal = ({ requestData, onClose, classes }) => {
  const modalRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = event => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose()
      }
    }

    const handleEscapeKeyPress = event => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleEscapeKeyPress)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleEscapeKeyPress)
    }
  }, [onClose])

  return (
    <div className={classes.timeOffModalContainer} ref={modalRef}>
      <div className={classes.modalTitle}>{'Request details'}</div>
      <span className={classes.close} onClick={onClose}>
        <CloseIcon />
      </span>
      <div className={classes.timeOffDataContainer}>
        <div className={classes.timeOffDataRow}>
          <div className={classes.timeOffDataRowLabel}>{`Type of leave: `}</div>
          <div className={classes.timeOffValue}>
            {requestData.paidType == PTO_REQUEST_PAID_TYPE_OF_TIME_OFF_ENUM
              ? 'Paid leave'
              : requestData.paidType == PTO_REQUEST_UNPAID_TYPE_OF_TIME_OFF_ENUM
              ? 'Unpaid leave'
              : '-'}
          </div>
        </div>
        <div className={classes.timeOffDataRow}>
          <div
            className={classes.timeOffDataRowLabel}
          >{`Reason of leave: `}</div>
          <div className={classes.timeOffValue}>
            {PTO_REQUEST_TYPE_ENUM_TO_READABLE[requestData.timeOffType]}
          </div>
        </div>
        <div className={classes.timeOffDataRow}>
          <div className={classes.timeOffDataRowLabel}>{`Leave start: `}</div>
          <div className={classes.timeOffValue}>
            {moment(requestData.startDate, 'YYYY-MM-DD').format('DD-MM-YYYY')}
          </div>
        </div>
        <div className={classes.timeOffDataRow}>
          <div className={classes.timeOffDataRowLabel}>{`Leave end: `}</div>
          <div className={classes.timeOffValue}>
            {moment(requestData.endDate, 'YYYY-MM-DD').format('DD-MM-YYYY')}
          </div>
        </div>
        <div className={classes.timeOffDataRow}>
          <div className={classes.timeOffDataRowLabel}>{`Comment: `}</div>
          <div className={classes.commentValue}>
            {requestData.userComment || '-'}
          </div>
        </div>
      </div>
      <div className={classes.cancelButton}>
        <GenericFlatButton type={'outline'} title={'Close'} onClick={onClose} />
      </div>
    </div>
  )
}

export default injectStyles(styles)(ViewTimeOffRequestModal)
